import { ApiError } from '@/api/http';
import { formatApiError } from '@/utils/formatApiError';

/** User-facing message when Run now fails. */
export function runSearchErrorMessage(err: unknown, fallback = 'Scrape failed'): string {
  if (err instanceof ApiError) {
    if (err.status === 403) {
      const detail = err.detail as { message?: string } | undefined;
      if (detail?.message) return detail.message;
      return 'Your workspace role cannot run this search.';
    }
    if (err.status === 404) {
      return 'Search not found or was removed.';
    }
  }
  return formatApiError(err, fallback);
}
